import React from "react";
import PropTypes from "prop-types";

const formatPublishedDate = (dateString) => {
  const date = new Date(dateString);
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options).replace(/, (\d) /, ", $1 ");
};

const CardPublishDate = ({ date = null, className = "" }) => {
  const formattedDate = formatPublishedDate(date || new Date());

  return (
    <div className={`card__date ${className}`}>
      <span>{formattedDate}</span>
    </div>
  );
};

CardPublishDate.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string
};

export default CardPublishDate;
